import { useState } from "react";
import React from "react";
import Layout from "../../../components/layout/layout";
import { FaSortDown, FaSortUp, FaStar } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { FaRegClock } from "react-icons/fa";
import packageIcon from "../../../assets/icons/packageIcone.png";
import tooltipDataNotFoundImg from "../../../assets/image/tooltipDataNotFoundImg.png";
import { SearchHeader } from "../../../components/seachHeader/SearchHeader";
import { useTooltipData } from "../../../hooks/useTooltipData";
import { useAppState } from "../../../hooks/useAppState";
import { Star, Search } from "lucide-react";
import {
  doc as fsDoc,
  getDoc as fsGetDoc,
  updateDoc as fsUpdateDoc,
  arrayUnion as fsArrayUnion,
  arrayRemove as fsArrayRemove,
  collection as fsCollection,
  query as fsQuery,
  where as fsWhere,
  getDocs as fsGetDocs,
} from 'firebase/firestore';
import { db as firebaseDb } from "../../../config/firebase";

// Utility function to format date
const formatPurchaseDate = (isoDate: string) => {
  const date = new Date(isoDate);
  const options: Intl.DateTimeFormatOptions = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  };
  return date.toLocaleString('en-US', options);
};

interface FilterOptions {
  amountRanges?: {
    range1?: boolean;
    range2?: boolean;
    range3?: boolean;
    range4?: boolean;
    range5?: boolean;
    range6?: boolean;
    custom?: boolean;
    customMin?: number | null;
    customMax?: number | null;
  };
  purchasesRating?: string;
}

const TooltipCustomer = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [appliedFilters, setAppliedFilters] = useState<FilterOptions | null>(null);
  const { user } = useAppState();

  // Sorting state
  const [sortColumn, setSortColumn] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  // Use the custom hook to fetch tooltip data
  const { 
    data, 
    loading, 
    error, 
    refetch, 
    saveRatingAndReview, 
    packageRatings, 
    loadingRatings,
    updatePackageSelection
  } = useTooltipData();

  const [rating, setRating] = useState(0); // Default 0 rating
  const [review, setReview] = useState(""); // Default empty review
  const [isSaving, setIsSaving] = useState(false);

  interface TooltipPackage {
    id: string;
    name: string;
    expert: string;
    date: string;
    amount: string;
    packageId: string;
    creatorId: string;
    price: number;
    createdAt: string;
    purchasedAt?: string;
    purchaseDocId?: string;
    rating?: number;
    review?: string;
    primaryUrl?: string;
    selected?: boolean;
    description?: string;
  }

  const [selectedPackage, setSelectedPackage] = useState<TooltipPackage | null>(null);
  const [modalIsOpenReview, setModalIsOpenReview] = useState(false);
  const [updatingSelection, setUpdatingSelection] = useState<string | null>(null);

console.log(selectedPackage,"selectedPackage")
  // Add pagination constants
  const itemsPerPage = 10;

  // Handle sorting
  const handleSort = (column: string, direction: 'asc' | 'desc') => {
    setSortColumn(column);
    setSortDirection(direction);
  };

  // Add function to close modal
  const onClose = () => {
    setModalIsOpenReview(false);
    setSelectedPackage(null);
    // Reset form values
    setRating(0);
    setReview("");
  };

  // Add function to open modal for write review button
  const handleWriteReviewClick = (item: TooltipPackage) => {
    setSelectedPackage(item);
    // Set existing rating and review if available
    setRating(item.rating || 0);
    setReview(item.review || "");
    setModalIsOpenReview(true);
  };

  // Add function to open modal for view button
  // Note: view action will open package URL (handled by handlePackageView).

     // Check if extension is installed and user is logged in
    const checkExtensionLogin = async (): Promise<boolean> => {
      return new Promise((resolve) => {
        try {
          if (window.chrome && window.chrome.runtime) {
            window.chrome.runtime.sendMessage(
              "ndcmfkbjobahmdpjakmgnomklohgalfc",
              { type: "CHECK_LOGIN" },
              (response) => {
                if (chrome.runtime.lastError) {
                  resolve(false);
                } else {
                  resolve(response?.success ?? false);
                }
              }
            );
          } else {
            resolve(false);
          }
        } catch (e) {
          console.error('Extension check error:', e);
          resolve(false);
        }
      });
    };
  // Handle opening package primary URL similar to QuickAccess
  const handlePackageView = async (packageId: string, primaryUrl?: string) => {
    if (!primaryUrl) {
      console.warn("No primary URL available for package:", packageId);
      alert("Package URL not available");
      return;
    }

    try {
        const extensionOk = await checkExtensionLogin();
        if (!extensionOk) {
          alert('Please ensure the extension is installed and you are logged in.');
          return;
        }
      const url = new URL(primaryUrl);
      url.searchParams.set('packageId', packageId);
      // If we have auth info in data, try to add a userId param if available
      const currentUserId = (data && data.length > 0 && data[0].creatorId) ? data[0].creatorId : undefined;
      if (currentUserId) {
        url.searchParams.set('userId', currentUserId);
      }

      // If running inside extension environment, use chrome.tabs.create when available
      if (typeof chrome !== 'undefined' && chrome?.tabs?.create) {
        chrome.tabs.create({ url: url.toString() });

        // Optionally send a tracking message to background
        if (chrome.runtime && chrome.runtime.sendMessage) {
          chrome.runtime.sendMessage(
            {
              type: 'TRACK_PACKAGE_VIEW',
              payload: { packageId, primaryUrl: primaryUrl }
            },
            (response) => {
              if (response?.success) {
                console.log('Package view tracked successfully');
              } else {
                // not critical, just log
                // console.warn('Failed to track package view:', response?.error);
              }
            }
          );
        }
      } else {
        // Fallback for non-extension environments
        window.open(url.toString(), '_blank');
      }
    } catch (error) {
      console.error('Error opening package URL:', error);
      alert('Failed to open package. Please try again.');
    }
  };

  // Add function to save rating and review
  const handleSaveReview = async () => {
    if (!selectedPackage?.purchaseDocId) {
      alert('Unable to save review: Purchase information not found');
      return;
    }

    if (rating === 0) {
      alert('Please select a rating before saving');
      return;
    }

    setIsSaving(true);
    try {
      await saveRatingAndReview(selectedPackage.purchaseDocId, rating, review);
      alert('Review saved successfully!');
      onClose();
    } catch (error) {
      console.error('Error saving review:', error);
      alert('Failed to save review. Please try again.');
    } finally {
      setIsSaving(false);
    }
  };

  // Function to handle package selection change
  const handleSelectionChange = async (packageId: string, selected: boolean) => {
    // Check for user authentication - prefer Firebase auth uid
    const userIdCandidate = user?.uid || user?.id || user?.userId || user?.email;

    if (!userIdCandidate) {
      console.warn("No user identifier available for selection update");
      alert("Please log in to update package selections");
      return;
    }

    // We'll attempt several strategies to locate the user document:
    // 1) assume doc id === uid (most common)
    // 2) query users collection where uid==user.uid or email==user.email
    // This makes the UX resilient to differences between user objects

    // Keep a snapshot to allow reverting on error
    const prevSnapshot = [...data];

    try {
      setUpdatingSelection(packageId);

      // Optimistic local update
      updatePackageSelection(packageId, selected);

      // Attempt direct doc lookup by uid first
      let userDocRef = fsDoc(firebaseDb, 'users', user?.uid || user?.id || String(userIdCandidate));
      let userDoc = await fsGetDoc(userDocRef);

      // If not found, try to locate by uid or email via query
      if (!userDoc.exists()) {
        // Build possible fallbacks
        const queries = [];
        if (user?.uid) {
          queries.push(fsQuery(fsCollection(firebaseDb, 'users'), fsWhere('uid', '==', user.uid)));
        }
        if (user?.email) {
          queries.push(fsQuery(fsCollection(firebaseDb, 'users'), fsWhere('email', '==', user.email)));
        }

        for (const q of queries) {
          const snap = await fsGetDocs(q);
          if (!snap.empty) {
            const first = snap.docs[0];
            userDocRef = fsDoc(firebaseDb, 'users', first.id);
            userDoc = await fsGetDoc(userDocRef);
            break;
          }
        }
      }

      if (!userDoc.exists()) {
        // No user doc found after fallbacks
        throw new Error('user_doc_not_found');
      }

      // Perform update using static updateDoc + arrayUnion/arrayRemove
      if (selected) {
        await fsUpdateDoc(userDocRef, {
          selectedPackages: fsArrayUnion(packageId),
          lastUpdated: new Date().toISOString(),
        });
      } else {
        await fsUpdateDoc(userDocRef, {
          selectedPackages: fsArrayRemove(packageId),
          lastUpdated: new Date().toISOString(),
        });
      }

      // Success - nothing more to do (real-time listeners will keep data fresh)
    } catch (error) {
      console.error('Error updating package selection:', error);

      // Revert optimistic update
      try {
        prevSnapshot.forEach((originalItem) => {
          updatePackageSelection(originalItem.packageId, originalItem.selected || false);
        });
      } catch (revertError) {
        console.error('Error reverting optimistic update:', revertError);
      }

      // Provide user-friendly message
      let message = 'Failed to update selection. Please try again.';
      if (error instanceof Error) {
        if (error.message === 'user_doc_not_found') {
          message = 'Failed to update selection. User account not found. Please try logging out and back in.';
        } else if (error.message.includes('permission')) {
          message = 'Failed to update selection. Permission denied.';
        } else {
          message = `Failed to update selection. ${error.message}`;
        }
      }

      alert(message);
    } finally {
      setUpdatingSelection(null);
    }
  };

  // Filter data based on search term
  let filteredData = data.filter(
    (item) =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.expert.toLowerCase().includes(searchTerm.toLowerCase()) ||
    
      (item.primaryUrl && item.primaryUrl.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (item.description && item.description.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  // Apply filters if any
  if (appliedFilters) {
    if (appliedFilters.amountRanges) {
      filteredData = filteredData.filter((item) => {
        const amount = parseFloat(item.amount.replace(/[^0-9.-]+/g, ''));
        let include = false;
        if (appliedFilters.amountRanges?.range1) include = include || (amount >= 0 && amount <= 10);
        if (appliedFilters.amountRanges?.range2) include = include || (amount > 10 && amount <= 25);
        if (appliedFilters.amountRanges?.range3) include = include || (amount > 25 && amount <= 50);
        if (appliedFilters.amountRanges?.range4) include = include || (amount > 50 && amount <= 100);
        if (appliedFilters.amountRanges?.range5) include = include || (amount > 100 && amount <= 500);
        if (appliedFilters.amountRanges?.range6) include = include || (amount > 500);
        if (appliedFilters.amountRanges?.custom) {
          const min = appliedFilters.amountRanges?.customMin || 0;
          const max = appliedFilters.amountRanges?.customMax || Infinity;
          include = include || (amount >= min && amount <= max);
        }
        return include;
      });
    }
    if (appliedFilters.purchasesRating) {
      const exactRating = parseInt(appliedFilters.purchasesRating as string);
      filteredData = filteredData.filter((item) => {
        const rating = item.rating || 0;
        return rating === exactRating;
      });
    }
  }

  // Apply sorting to filtered data
  const sortedData = React.useMemo(() => {
    const sorted = [...filteredData];
    if (sortColumn) {
      sorted.sort((a, b) => {
        // Name sorting (string) — use localeCompare for correct alphabetical order
        if (sortColumn === 'name') {
          const aName = (a.name || '').toString().toLowerCase();
          const bName = (b.name || '').toString().toLowerCase();
          const cmp = aName.localeCompare(bName);
          return sortDirection === 'asc' ? cmp : -cmp;
        }

        // Expert name sorting (string)
        if (sortColumn === 'expert') {
          const aExpert = (a.expert || '').toString().toLowerCase();
          const bExpert = (b.expert || '').toString().toLowerCase();
          const cmp = aExpert.localeCompare(bExpert);
          return sortDirection === 'asc' ? cmp : -cmp;
        }

        // Amount sorting (numeric)
        if (sortColumn === 'amount') {
          const aAmount = parseFloat(a.amount.replace(/[^0-9.-]+/g, '')) || 0;
          const bAmount = parseFloat(b.amount.replace(/[^0-9.-]+/g, '')) || 0;
          return sortDirection === 'asc' ? aAmount - bAmount : bAmount - aAmount;
        }

        return 0;
      });
    }
    return sorted;
  }, [filteredData, sortColumn, sortDirection]);

  // Calculate pagination
  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle page change
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  return (
    <Layout>
      <div
        className="p-6 mx-auto bg-white rounded-xl"
        style={{
          height: "calc(100vh - 112px)",
          overflowY: "hidden",
          overflowX: "hidden"
        }}
      >
        {/* Replace the existing header with SearchHeader */}
        <SearchHeader
          title="My Purchases"
          onSearch={setSearchTerm}
          onFilter={setAppliedFilters}
          appliedFilters={appliedFilters}
          hasPurchasesTooltipFilter={true}
        />

        <div
          className="bg-white rounded-[12px] border-[1px] border-[#EBEBEB] overflow-hidden"
          style={{
            height: "calc(80vh - 100px)",
            overflowY: "auto",
            overflowX: "hidden"
          }}
        >
          <table className="min-w-full  divide-y max-h-[751px] divide-gray-200">
            <thead className="bg-[#FEF0EA]">
              <tr>
                 <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                  Status
                </th>
                <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                  <div className="flex items-center justify-between">
                    <span>Package ID</span>
                  </div>
                </th>
                <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                   <div className="flex items-center gap-2">
                
                                  <span>
                                  Package Name
                                  </span>
                                  <span className="col-span-1 flex flex-col">
                
                                      <button onClick={() => handleSort('name', 'asc')}>
                                        <FaSortUp className={`w-3 h-3 ${sortColumn === 'name' && sortDirection === 'asc' ? 'text-[#f15d18]' : 'text-gray-500'}`} />
                                      </button>
                                      <button onClick={() => handleSort('name', 'desc')}>
                                        <FaSortDown className={`w-3 h-3 ${sortColumn === 'name' && sortDirection === 'desc' ? 'text-[#f15d18]' : 'text-gray-500'}`} />   </button>
                                      </span>
                                  </div>
                </th>
                <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                  <div className="flex items-center justify-between">
                    <span>Package URL</span>
                  </div>
                </th>
                <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                  <div className="flex items-center justify-between">
                    <span>Description</span>
                  </div>
                </th>
                <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                 
                  <div className="flex items-center gap-2">
                
                                  <span>Expert Name</span>
                                  <span className="col-span-1 flex flex-col">
                
                                      <button onClick={() => handleSort('expert', 'asc')}>
                                        <FaSortUp className={`w-3 h-3 ${sortColumn === 'expert' && sortDirection === 'asc' ? 'text-[#f15d18]' : 'text-gray-500'}`} />
                                      </button>
                                      <button onClick={() => handleSort('expert', 'desc')}>
                                        <FaSortDown className={`w-3 h-3 ${sortColumn === 'expert' && sortDirection === 'desc' ? 'text-[#f15d18]' : 'text-gray-500'}`} />   </button>
                                      </span>
                                  </div>
                </th>
                <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                  Purchased
                </th>
                <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                 
                  <div className="flex items-center gap-2">
                
                                  <span>
                                Amount
                                  </span>
                                  <span className="col-span-1 flex flex-col">
                
                                      <button onClick={() => handleSort('amount', 'asc')}>
                                        <FaSortUp className={`w-3 h-3 ${sortColumn === 'amount' && sortDirection === 'asc' ? 'text-[#f15d18]' : 'text-gray-500'}`} />
                                      </button>
                                      <button onClick={() => handleSort('amount', 'desc')}>
                                        <FaSortDown className={`w-3 h-3 ${sortColumn === 'amount' && sortDirection === 'desc' ? 'text-[#f15d18]' : 'text-gray-500'}`} />   </button>
                                      </span>
                                  </div>
                </th>
                   <th className="px-2 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                    Reviews
                  </th>
                <th className="px-3 py-3 text-left text-[14px] nunito-semibold text-[#404040] tracking-wider">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan={10}>
                    <div className="flex flex-col items-center mt-[70px]">
                      <div className="text-[18px] nunito-semibold text-[#696969]">
                        Loading tooltip packages...
                      </div>
                    </div>
                  </td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan={10}>
                    <div className="flex flex-col items-center mt-[70px]">
                      <div className="text-[18px] nunito-semibold text-[#696969]">
                        Error: {error}
                      </div>
                      <button 
                        onClick={refetch}
                        className="mt-4 px-4 py-2 bg-[#F15D18] text-white rounded-lg"
                      >
                        Retry
                      </button>
                    </div>
                  </td>
                </tr>
              ) : currentItems.length === 0 ? (
                searchTerm.trim() !== "" ||
                (appliedFilters && (
                  (appliedFilters.amountRanges && Object.values(appliedFilters.amountRanges || {}).some(Boolean)) ||
                  (appliedFilters.purchasesRating && appliedFilters.purchasesRating !== "")
                )) ? (
                  <tr>
                    <td colSpan={10}>
                      <div className="flex flex-col items-center py-20">
                        <div className="w-24 h-24 mb-4 flex items-center justify-center">
                          <Search className="w-16 h-16 text-gray-400" />
                        </div>
                        <h2 className="text-[24px] nunito-semibold text-[#404040] mb-2">
                          Opps! No matching records found.
                        </h2>
                        <p className="text-[#919191] text-[14px] nunito-semibold mb-4 text-center">
                          Try changing the filters or search criteria to see more
                          results!
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={10}>
                      <div className="flex flex-col items-center mt-[70px]">
                        <div className="w-[416px] h-[214px] mb-4 flex items-center justify-center">
                          <img src={tooltipDataNotFoundImg} alt="data not found"/>
                        </div>
                        <h2 className="text-[24px] nunito-semibold mt-2 text-[#404040]">
                          Oops! Nothing here yet.
                        </h2>
                      </div>
                    </td>
                  </tr>
                )
              ) : (
                currentItems.map((item, index) => (
                  <tr key={index} className={` ${selectedPackage?.id === item.id ? 'bg-gray-100' : ''}`}>
                      <td className="px-2 py-3 whitespace-nowrap">
                      <label className=" relative group inline-flex items-center cursor-pointer">
                        {/* Replace direct checkbox toggle with confirmation flow */}
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          checked={item.selected || false}
                          onChange={(e) => handleSelectionChange(item.packageId, e.target.checked)}
                          disabled={updatingSelection === item.packageId}
                        />
                        <div className={`w-11 h-6 rounded-full peer peer-focus:ring-4 peer-focus:ring-orange-300 peer-checked:bg-orange-500 peer-checked:after:translate-x-5 peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all ${
                          item.selected ? 'bg-orange-500' : 'bg-gray-200'
                        } ${updatingSelection === item.packageId ? 'opacity-50 cursor-not-allowed' : ''}`}></div>
                        {/* Hover tooltip shows enable/disable message dynamically */}
                         <div className="absolute left-0 -translate-y-1/2 -top-4 px-2 py-1 min-w-max bg-[#FAFAFA] nunito-regular text-[12px] text-[#696969] rounded-[8px] shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 z-30 break-words">
                         {updatingSelection === item.packageId ? 'Updating...' : (item.selected ? 'Disable tooltip' : 'Enable tooltip')}
                        </div>
                      </label>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                     <div className="relative inline-block group max-w-[160px]">
                        {/* Truncated visible text */}
                        <span className="block truncate text-[14px] nunito-semibold  text-[#696969]" aria-label={item.id || ''}>
                          {((item .id || '').toString().length > 5)
                            ? `${(item.id || '').toString().slice(0, 5)}...`
                            : item.id}
                        </span>

                        {/* Styled hover tooltip showing full packageId */}
                        <div className="absolute left-0 -translate-y-1/2 -top-4 px-2 py-1 min-w-max bg-[#FAFAFA] nunito-regular text-[12px] text-[#696969] rounded-[8px] shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 z-30 break-words">
                          {item.id}
                        </div>
                      </div>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <div className="text-[14px] nunito-semibold  truncate max-w-36 text-[#696969]">
                        {item.name}
                      </div>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                       <div className="relative inline-block group max-w-[160px]">
                      <div className="text-[14px] nunito-semibold  truncate max-w-36 text-[#696969]">
                        {item.primaryUrl}
                      </div>
                       {/* Styled hover tooltip showing full packageId */}
                        <div className="absolute left-0 -translate-y-1/2 -top-4 px-2 py-1 min-w-max bg-[#FAFAFA] nunito-regular text-[12px] text-[#696969] rounded-[8px] shadow-lg opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 z-30 break-words">
                          {item.primaryUrl}
                        </div>
                      </div>
                    </td>
                     <td className="px-2 py-3 whitespace-nowrap">
                      <label className=" relative group inline-flex items-center cursor-pointer">
                      <div className="text-[14px] nunito-semibold truncate max-w-44 text-[#696969]">
                        {item.description}
                      </div>
                       <div className="absolute left-0 -top-4 -translate-y-1/2 px-2 py-1 w-[200px]  bg-[#FAFAFA]  nunito-regular text-[12px] text-[#696969] rounded-[8px] shadow-lg opacity-0 group-hover:opacity-100 group-hover:pointer-events-auto pointer-events-none transition-opacity duration-200 z-30">
                          <div className="text-start break-words whitespace-pre-line">
                            <div className="nunito-regular text-[12px] text-[#696969] break-words whitespace-pre-line">
                              {item.description}
                            </div>
                            </div>
                          
                      </div>
                      </label>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <div className="text-[14px] nunito-regular truncate max-w-36 text-[#696969]">
                        {item.expert}
                      </div>
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-[14px] nunito-regular text-[#696969]">
                      {item.date}
                    </td>
                    <td className="px-3 py-3 whitespace-nowrap text-[14px] nunito-regular text-[#696969]">
                      {item.amount}
                    </td>
                   <td className="px-2 py-3 whitespace-nowrap">
                      <label className=" relative group inline-flex items-center cursor-pointer">
   <div className="flex items-center">
                      <span className="text-[#696969]">
                          {item.rating}
                        </span>
                           <span className="  ml-1"><Star className="text-[#F5A038] fill-[#F5A038] w-[24px] h-[24px]"/></span>
                      </div>
                        {/* Tooltip on hover */}
                       {(item.review && item.review.length > 0) && (

                          <div className="absolute left-10 top-1/2 -translate-y-1/2 px-2 py-1 w-[200px]  bg-[#FAFAFA]  nunito-regular text-[12px] text-[#696969] rounded-[8px] shadow-lg opacity-0 group-hover:opacity-100 group-hover:pointer-events-auto pointer-events-none transition-opacity duration-200 z-30">
                          <div className="text-start break-words whitespace-pre-line">
                            <div className="nunito-regular text-[12px] text-[#696969] break-words whitespace-pre-line">
                              {item.review}
                            </div>
                            </div>
                          
                      </div>
                        )}
                       {/* <div className="absolute left-12 top-1/2 -translate-y-1/2 px-2 py-1 bg-black text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-30 pointer-events-none">
                          {updatingSelection === item.packageId ? 'Updating...' : (item.selected ? 'Disable tooltip' : 'Enable tooltip')}
                        </div> */}
                      </label>

                    </td>
                    <td className="px-3 py-3 whitespace-nowrap">
                      <div className="flex justify-between">
                        <button
                          className="text-[#696969] mr-2 text-[14px] nunito-regular"
                          onClick={() => handleWriteReviewClick(item)}
                        >
                          {item.rating && item.rating > 0 ? 'Edit Review' : 'Write Review'}
                        </button>
                        <button
                          className="text-[#F15D18] text-[14px] nunito-semibold"
                          onClick={() => handlePackageView(item.packageId, item.primaryUrl)}
                        >
                          View
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {!loading && !error && currentItems.length > 0 && totalPages > 1 && (
          <div className="py-3 flex items-center justify-center mt-">
            <nav className="flex space-x-1">
              {[...Array(totalPages)].map((_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={`px-2 py-1 text-[#696969] ${
                    currentPage === index + 1
                      ? "bg-[#FAFAFA] border-[#EBEBEB] rounded-[8px] border"
                      : ""
                  }`}
                >
                  {String(index + 1).padStart(2, "0")}
                </button>
              ))}
            </nav>
          </div>
        )}
      </div>
      {modalIsOpenReview && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white  w-[554px] rounded-xl shadow-lg p-6">
            <div className="flex justify-between items-center mb-3">
              <h2 className=" nunito-semibold text-[24px] text-[#0A0A0A]">
                {selectedPackage?.rating && selectedPackage.rating > 0 ? 'Edit your review' : 'Write a review'}
              </h2>
              <div className="">
                <button onClick={onClose} >
                  <IoClose className="text-[#696969]  w-[32px] h-[32px] "/>
                </button>
              </div>
            </div>

            <div className="flex items-center justify-between bg-white rounded-[16px] border-[#D9D9D9]  p-4 w-[500px] border">
              {/* Left Section - Icon & Details */}
              <div className="flex items-center">
                <div className="p-3 bg-[#FEF0EA] w-[75px] h-[75px] rounded-[16px]">
                  <img
                    src={packageIcon}
                    alt="Package Icon"
                    className="w-[48px] h-[48px] object-cover rounded-md"/>
                  {/* <BsBoxFill size={50} className="text-[#F15D18]" /> */}
                </div>
                <div className="ml-4">
                  <h3 className="text-[20px] text-[#0A0A0A] nunito-semibold">
                    {selectedPackage?.name}
                  </h3>
                  <p className="text-[#696969] flex items-center">
                    <FaStar className="text-[#F15D18] w-[13px] h-[12px]  mr-1" />
                    <span className="text-[14px] nunito-regular">
                      {loadingRatings ? (
                        'Loading ratings...'
                      ) : selectedPackage?.packageId && packageRatings[selectedPackage.packageId] ? (
                        `${packageRatings[selectedPackage.packageId].avgRating} (${packageRatings[selectedPackage.packageId].totalReviews} ${packageRatings[selectedPackage.packageId].totalReviews === 1 ? 'review' : 'reviews'})`
                      ) : (
                        '0.0 (0 reviews)'
                      )}
                    </span>
                  </p>
                  <p className=" flex items-center ">
                    <FaRegClock className="mr-1 w-[13px] h-[13px] text-[#696969]" /> <span className="text-[12px] nunito-regular text-[#696969]">
                    {selectedPackage?.purchasedAt ? formatPurchaseDate(selectedPackage.purchasedAt) : 'N/A'}
                      </span>
                  </p>
                </div>
              </div>

              {/* Right Section - Price */}
              <div className="text-right">
                <p className="text-[#F15D18] nunito-bold text-[20px]">
                  {selectedPackage?.amount}
                </p>
                <p className="text-[#919191] text-[14px] nunito-semibold">One-time</p>
              </div>
            </div>

            <div className="bg-white mt-3 p-4 rounded-[16px] border-[#D9D9D9]  w-[500px] border">
              {/* Tooltip Rating Section */}
              <h3 className="text-[16px] text-[#404040] nunito-semibold mb-2">Tooltip Rating</h3>
              <div className="flex space-x-2">
                {[1, 2, 3, 4, 5].map((num) => (
                  <FaStar
                    key={num}
                    className={`text-2xl w-[34px] h-[33px] cursor-pointer ${
                      num <= rating ? "text-[#F15D18]" : "text-[#EBEBEB]"
                    }`}
                    onClick={() => setRating(num)}
                  />
                ))}
              </div>

              {/* Tooltip Review Section */}
              <h3 className="text-[16px] nunito-semibold text-[#404040] mt-4 mb-2">
                Tooltip Review
              </h3>
              <input
                type="text"
                value={review}
                placeholder={selectedPackage?.review ? "Update your review..." : "Write your review here..."}
                onChange={(e) => setReview(e.target.value)}
                className="w-full border p-2 rounded-[6px] text-[14px] text-[#404040] focus:outline-none border-[#404040] focus:ring-2  focus:ring-[#404040]"
              />

              {/* Save Button */}
            </div>
            <div className="flex justify-center">
              <button 
                className="mt-4 h-[40px] bg-[#F15D18] w-[120px] text-[16px] nunito-bold text-white px-2 py-1 rounded-[8px] disabled:opacity-50"
                onClick={handleSaveReview}
                disabled={isSaving}
              >
                {isSaving ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default TooltipCustomer;
